import React from 'react';
import { Layout, Pagination } from 'antd';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Head from 'next/head';
import Router from 'next/router';
import {
  makeSelectTemplates,
  makeSelectCurrentPage,
  makeSelectTotalPage,
  makeSelectNumberPage,
  makeSelectIsLoadingTemplates,
} from './selectors';
import LayoutEditorAC from '../DemoHomePageContainer/Layout';
import GridLayout from '../HomePageContainer/GridLayout';
import withi18next from '~/hocs/withi18next';
import {
  loadNewContent,
  loadPopularContent,
  loadSearchContent,
} from '~/containers/TemplatePageContainer/actions';
import { loadMetaData } from '~/containers/MetaDataProvider/actions';
import SEOHead from '~/components/SharingMeta/SEOHead';
import { USER_ROLES } from '~/config';
import { colors } from '~/config/theme';
import Breadcrumb from '~/components/Breadcrumb';
import PaginationRenderItem from '~/components/JumpPagePagination/PaginationRenderItem';

const { Content } = Layout;

@withi18next()
class TemplatePageContainer extends React.Component {
  state = {
    loadPopularTemplate: false,
    page: this.props?.query?.page || null,
  };
  componentDidUpdate() {
    const {
      type,
      isSearching,
      totalCategoryPageTemplates,
      loadPopularContent,
    } = this.props;
    const { loadPopularTemplate } = this.state;
    if (
      type === 'search' &&
      !isSearching &&
      totalCategoryPageTemplates === 0 &&
      !loadPopularTemplate
    ) {
      this.setState({ loadPopularTemplate: true });
      loadPopularContent(1);
    }
  }

  handleChangePage = (page, pageSize) => {
    const currentLang = this.props.i18n.language;
    const scrollTopHashE = document.getElementById('scroll-top-hash');
    const {
      type,
      userProfile,
      loadNewContent,
      loadPopularContent,
      loadSearchContent,
      keyword,
    } = this.props;
    const { loadPopularTemplate } = this.state;
    const routerQuery = {
      ...Router.router.query,
      page,
    };
    Object.keys(routerQuery).forEach((key) => {
      if ([null, undefined].includes(routerQuery[key])) delete routerQuery[key];
    });
    Router.push(
      `${currentLang === 'ja' ? '' : `/${currentLang}`}/templates/${
        this.props.type
      }?${new URLSearchParams(routerQuery).toString()}`,
      undefined,
      { shallow: true },
    ).then(() =>
      window.scrollTo(0, scrollTopHashE ? scrollTopHashE.offsetTop : 0),
    );

    if (type === 'new') {
      loadNewContent(
        page,
        userProfile ? userProfile.role : USER_ROLES.USER,
        currentLang,
      );
    } else if (type === 'popular') {
      loadPopularContent(page);
    } else if (type === 'search' && !loadPopularTemplate) {
      loadSearchContent(keyword, page);
    } else if (type === 'search' && loadPopularTemplate) {
      loadPopularContent(page);
    }
    this.setState({ page });
  };

  render() {
    const {
      t,
      type,
      i18n,
      keyword,
      dataSource,
      isSearching,
      isLoadingCategoryPageTemplates,
      totalCategoryPageTemplates,
      numberPagesOfCategoryPage,
      currentPageOfCategoryPageTemplate,
      query,
    } = this.props;
    const { loadPopularTemplate, page } = this.state;
    let currentLang = i18n.language;
    if (currentLang === 'ja') {
      currentLang = 'jp';
    }

    let metaName = '';
    let metaDescription = '';
    let metaKeyword = '';
    let metaIntroduction = '';
    switch (type) {
      case 'new':
        metaName = t('ace-text-new-templates');
        metaDescription = t('ace-meta-new-page-description');
        metaKeyword = t('ace-meta-new-page-keywords');
        metaIntroduction = t('ace-meta-new-page-introduction');
        break;
      case 'popular':
        metaName = t('ace-text-popular-content');
        metaDescription = t('ace-meta-popular-page-description');
        metaKeyword = t('ace-meta-popular-page-keywords');
        metaIntroduction = t('ace-meta-popular-page-introduction');
        break;
      case 'search':
        metaName = t('ace-meta-searchpage-title', { keyword });
        metaDescription = t('ace-meta-searchpage-description', {
          keyword,
          total: totalCategoryPageTemplates,
        });
        break;
      default:
        break;
    }

    let bannerImgUrl = '/static/images/Background-slideshow-EditorAC.jpg';
    let bannerSrcSet = '/static/images/Background-slideshow-EditorAC.jpg';
    let bannerMobile = '/static/images/Background-slideshow-EditorAC-600.jpg';
    let bannerTablet = '/static/images/Background-slideshow-EditorAC-900.jpg';
    let bannerDesktop = '/static/images/Background-slideshow-EditorAC-1440.jpg';
    let titleBanner = '';
    let extraClass = '';
    if (
      query.src === 'homepage-banner' ||
      keyword
        ?.toLowerCase()
        ?.includes(t('text-tag-day-of-mother').toLowerCase())
    ) {
      bannerImgUrl = '/static/images/search-page-event-banner.jpg';
      bannerSrcSet = '/static/images/search-page-event-banner.jpg';
      bannerMobile = '/static/images/search-page-event-banner-600.jpg';
      bannerTablet = '/static/images/search-page-event-banner-900.jpg';
      bannerDesktop = '/static/images/search-page-event-banner-1440.jpg';
      metaIntroduction = t('search-page-mother-day-description-banner');
      titleBanner = t('search-page-mother-day-title-banner');
      extraClass = 'banner';
    }

    return (
      <>
        <Head>
          <title>
            {type === 'search'
              ? metaName
              : `${metaName} - ${t('ace-text-homepage-text')}designAC`}
          </title>
          <meta name="description" content={metaDescription} />
          <meta name="keywords" content={metaKeyword} />
        </Head>
        <SEOHead
          path={`templates/${type}${
            type === 'search'
              ? `?keyword=${keyword}${
                  page && parseInt(page) !== 1 ? `&page=${page}` : ''
                }`
              : `${page && parseInt(page) !== 1 ? `?page=${page}` : ''}`
          }`}
          lang={currentLang}
        />
        <LayoutEditorAC dataSource={dataSource || []} keyword={keyword}>
          {/* <div
            id="scroll-top-hash"
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              margin: 'auto',
              width: '100%',
              height: '360px',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src="https://data.editor-ac.com/data/banners/Background-slideshow-EditorAC.jpg"
              style={{ display: 'block' }}
            />
          </div> */}
          <div
            style={{
              // height: '360px',
              width: '100%',
              backgroundColor: 'rgba(246, 242, 239, 0.25)',
              backgroundImage:
                'linear-gradient(90deg,rgba(0,0,0,.01),rgba(0,0,0,.1))',
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              justifyContent: 'flex-start',
              padding: '0px',
              zIndex: '9',
              position: 'relative',
            }}
            className={`banner-wrapper ${extraClass}`}
          >
            <div
              id="scroll-top-hash"
              style={{
                width: '100%',
                minHeight: 300,
              }}
            >
              <picture>
                <source media="(max-width:600px)" srcSet={bannerMobile} />
                <source media="(max-width:900px)" srcSet={bannerTablet} />
                <source media="(max-width:1440px)" srcSet={bannerDesktop} />
                <img
                  className="lazyload"
                  data-src={bannerImgUrl}
                  srcSet={bannerSrcSet}
                  style={{
                    display: 'block',
                    width: '100vw',
                    height: 300,
                    objectFit: 'cover',
                  }}
                  loading="eager"
                  decoding="sync"
                  alt={metaDescription}
                />
              </picture>
            </div>

            <div className="template-page-container__image-banner">
              <h1
                style={{
                  color: colors.textNormal,
                  fontSize: '40px',
                  fontWeight: '600',
                }}
              >
                {titleBanner || metaName}
              </h1>
              <p className="banner-description">{metaIntroduction}</p>
            </div>
          </div>
          <Content
            style={{
              width: '100%',
              padding: '30px',
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                marginBottom: 24,
              }}
              className="breadcrum-wrapper"
            >
              <Breadcrumb
                style={{ marginBottom: 0 }}
                breadcrumbs={[
                  { name: t('ace-breadcrumb-home'), href: '/' },
                  {
                    name: metaName,
                    href:
                      type === 'search'
                        ? `/${
                            i18n.language === 'ja' ? '' : `${i18n.language}/`
                          }templates/search?keyword=${keyword}`
                        : `/templates/${type}`,
                  },
                ]}
              />
              <div style={{ marginTop: 8 }}>
                {totalCategoryPageTemplates > 0 && (
                  <span>
                    {t('ace-text-total-templates', {
                      total: totalCategoryPageTemplates,
                      subText:
                        type === 'search' && keyword
                          ? t('ace-subtext-for-total', { text: keyword })
                          : '',
                    })}
                  </span>
                )}
              </div>
            </div>
            {loadPopularTemplate && !isSearching && (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <p>{t('ace-text-search-not-found', { keyword })}</p>
              </div>
            )}
            <GridLayout
              {...this.props}
              isLoadingTemplates={isLoadingCategoryPageTemplates || isSearching}
              isTemplatePage={type}
              isSearchPage={type === 'search'}
              searchKeyword={keyword}
            />
            {totalCategoryPageTemplates > 0 && (
              <Pagination
                current={currentPageOfCategoryPageTemplate}
                pageSize={
                  totalCategoryPageTemplates / numberPagesOfCategoryPage
                }
                total={totalCategoryPageTemplates}
                onChange={this.handleChangePage}
                defaultCurrent={1}
                style={{
                  textAlign: 'center',
                  marginTop: 50,
                }}
                itemRender={(page, pageType, originalElement) => {
                  const prefix =
                    type === 'search'
                      ? `/templates/${type}?keyword=${keyword}&`
                      : `/templates/${type}?`;

                  return (
                    <PaginationRenderItem
                      pageType={pageType}
                      prefix={prefix}
                      page={page}
                      currentPageOfCategoryPageTemplate={
                        currentPageOfCategoryPageTemplate
                      }
                      originalElement={originalElement}
                    />
                  );
                }}
              />
            )}
          </Content>
          {currentLang === 'jp' &&
            type === 'search' &&
            keyword === '暑中見舞い' && (
              <div
                style={{
                  padding: 24,
                  borderRadius: 8,
                  margin: '10px 30px 30px 30px',
                  background: 'rgb(237, 240, 242)',
                }}
              >
                <h2
                  style={{
                    fontSize: 18,
                    fontWeight: 'bold',
                    marginBottom: '1.2em',
                  }}
                >
                  テンプレートを使って無料でオリジナル暑中見舞いを作成しよう！暑中見舞い作成の基本から、テンプレートを使った暑中見舞いの作成方法までを解説
                </h2>
                <p>
                  夏の挨拶状といえば「暑中見舞い」。厳しい暑さが続く中でも、暑中見舞いをもらうと気持ちがさわやかになります。
                </p>
                <p>
                  最近では、かわいいイラストなどの心和むデザインも増えて、カジュアルに楽しんでいる人も増えています。ビジネスシーンのコミュニケーションとしてはもちろん、日頃お世話になっている人や普段なかなか会えない人に、メールやSNSでは伝わらない気持ちを届けてみませんか？
                </p>
                <p>
                  今回は、暑中見舞いの書き方や歴史、暑中見舞いを作成するコツについて解説していきます。
                </p>
                <br />

                <h2
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: '1.2em',
                  }}
                >
                  暑中見舞いとは？
                </h2>
                <p>
                  暑中見舞いとは、猛暑の厳しい時期に相手の健康を気遣い、無事に過ごしてほしいことを願う挨拶状です。
                </p>
                <p>
                  二十四節気でいう小暑（7月7日頃）から立秋（8月7日頃）前までの間に送るものとされています。送るのが早すぎると梅雨時期に重なることがあるので、送り先の梅雨明け以降に送るとよいでしょう。また、暑さのピークとされる立秋（8月7日）を過ぎてしまった場合は、残暑見舞いに切り替えて送るようにしましょう。
                </p>
                <br />

                <h2
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: '1.2em',
                  }}
                >
                  暑中見舞いの由来と歴史
                </h2>
                <p>
                  暑中見舞いの由来にあたる習慣は、江戸時代からはじまったとされています。当時、お盆に里帰りする際、お供えの品を持ち帰り祖先の霊にささげていました。江戸時代以降は、普段からお世話になっている人への贈答の習慣が定着し、遠方の人には贈り物や書状を送るようになりました。
                </p>
                <p>
                  1971年に郵便はがきが発行され、この贈答の習慣が次第に挨拶状を送る習慣に変わっていきます。大正時代になり、今の「暑中見舞い」という形で定着したといわれています。
                </p>
                <br />

                <h2
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: '1.2em',
                  }}
                >
                  暑中見舞いの書き方
                </h2>
                <p>
                  暑中見舞いの文章は、寒中見舞いと同じく基本構成は決まっています。
                </p>
                <ul>
                  <li>季節の挨拶</li>
                  <li>本文</li>
                  <li>結びの挨拶</li>
                  <li>年号</li>
                </ul>
                <p>
                  構成に当てはめると、文章作成もスムーズになります。ネット上のさまざまな例文を応用し、ご自身の状況にあった例文を組み合わせるとよいでしょう。
                </p>
                <p>
                  <strong>・季節の挨拶 </strong>
                </p>
                <p>
                  出だしは「暑中お見舞い申し上げます」と書き出しましょう。続けて「日ごとに暑さが厳しくなってまいりましたが、お変わりありませんでしょうか。」と季節の挨拶を続けます。
                </p>
                <ul>
                  <li>
                    梅雨も明けて暑さも本格的になってまいりましたが、いかがお過ごしでしょうか。
                  </li>
                  <li>厳しい暑さの毎日ですがいかがお過ごしでしょうか。</li>
                  <li>
                    今年は冷夏でいまひとつカラッとしない天気が続いておりますが、皆様はいかがお過ごしでしょうか。
                  </li>
                </ul>
                <p>
                  季節の挨拶は、その時期を感じさせる状況をつづり、相手方を気遣う言葉を添えましょう。
                </p>
                <p>
                  <strong>・本文</strong>
                </p>
                <p>
                  本文では自身のプライベートのことや仕事のことに触れ、近況を報告するとよいでしょう。取引先やビジネスパートナーには、仕事とは違った一面を見せてもよいかもしれません。
                </p>
                <ul>
                  <li>
                    おかげさまで私ども一同、相変わらず元気に暮らしておりますのでご安心ください。
                  </li>
                  <li>家族一同、いたって元気に過ごしております。</li>
                  <li>我が家の子供たちは、元気いっぱいです。</li>
                  <li>
                    今年こそ、そちらへお邪魔しようと計画していますので、その節はどうぞよろしくお願いします。
                  </li>
                </ul>
                <p>
                  <strong>・結びの挨拶</strong>
                </p>
                <p>
                  結びの挨拶では、再度相手の健康を気遣い、思いやりのある一文で締めくくりましょう。
                </p>
                <ul>
                  <li>
                    暑い日が続きですが、体調を崩されませんようご自愛ください
                  </li>
                  <li>
                    この暑さはまだしばらく続きそうです。皆様くれぐれもご自愛くださいますようお祈り申し上げます。
                  </li>
                  <li>体調には十分注意して楽しい夏をお過ごし下さい。</li>
                </ul>
                <p>
                  結びの挨拶は、相手の状況や関係性にあわせて選ぶとよいでしょう。
                </p>
                <p>
                  <strong>・年号</strong>
                </p>
                <p>
                  暑中見舞いの最後に「令和〇〇年
                  盛夏」と和暦で書きましょう。残暑見舞いの場合は「晩夏」「立秋」「葉月」などの言葉を用います。
                </p>
                <br />

                <h2
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: '1.2em',
                  }}
                >
                  暑中見舞いのマナー
                </h2>
                <p>
                  暑中見舞いは、年賀状や寒中見舞いとは少しマナーが異なります。
                </p>
                <p>
                  <strong>・喪中の相手に対して送る場合</strong>
                </p>
                <p>
                  暑中見舞いは、喪中の相手に対しても出してよいとされています。ただし、四十九日の期間中は相手に気を使わせてしまうことになりかねないため、時期をずらし残暑見舞いに切り替えてもよいでしょう。
                </p>
                <p>
                  <strong>・お中元を送った場合</strong>
                </p>
                <p>
                  お中元は品物を送り、暑中見舞いははがきでおくります。お中元は7月15日から8月15日までとされ暑中見舞いのタイミングと重なりますが、お中元の後に暑中見舞いを送っても問題ないとされています。
                </p>
                <p>
                  <strong>・句読点の使用に注意</strong>
                </p>
                <p>
                  暑中見舞いや残暑見舞いは、年賀状と同様句読点をつけないのが正しいとされています。しかし、暑中見舞いは比較的カジュアルな挨拶状として句読点をつけて送る人も多いです。ビジネスの取引先や目上の人は避けるなど、相手によって使い分けができるとよいでしょう。
                </p>
                <br />

                <h2
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: '1.2em',
                  }}
                >
                  暑中見舞いを作成する際のコツ
                </h2>
                <p>
                  暑中見舞いはカジュアルな挨拶状として、楽しみながら作成するのがポイントです。暑中見舞いをデザインする際のコツについて解説します。
                </p>
                <p>
                  <strong>1. 送る相手に合わせたデザインを選ぶ</strong>
                </p>
                <p>
                  年賀状と同様ですが、カジュアルといっても送る相手に失礼がないデザインを選びましょう。
                </p>
                <p>
                  ビジネスの取引先や目上の人であれば、少し落ち着いた印象のイラストを取り入れるなど、カジュアルにし過ぎないほうが好ましいです。ネット上には暑中見舞いのデザインが豊富にアップされているので、いろいろなデザインを参考にしてみるとよいでしょう。
                </p>
                <p>
                  <strong>2. 出だしの挨拶文は大きめに書く</strong>
                </p>
                <p>
                  冒頭の「暑中お見舞い申し上げます」は少し大きめの文字で書きましょう。暑中見舞いも挨拶状ですので、ひとめで暑中見舞いとわかるのが望ましいです。
                </p>
                <p>
                  <strong>3. 涼しげな配色を使う</strong>
                </p>
                <p>
                  赤や黄色などの元気な色を使うのもよいですが、青系の色を使うと涼しげな印象になります。また、背景色やイラストの色も少し淡い色合いにすることで涼しさを演出できます。
                </p>
                <p>
                  <strong>4. イラストを入れる</strong>
                </p>
                <p>
                  親しい間柄であれば、かわいいイラストや手書きのイラストを入れてみるとよいでしょう。スイカ・花火・ひまわり・かき氷のような夏の風物詩を、背景やワンポイントで配置してみましょう。イラストがあるだけで夏の雰囲気を感じられるのでおすすめです。
                </p>
                <p>
                  <strong>5. 手書きのメッセージを添える</strong>
                </p>
                <p>
                  印刷したものとは別に手書きのメッセージを添えてみましょう。たった一言でも手書きのメッセージが入っていると、もらった相手はうれしいものです。
                </p>
                <br />

                <h2
                  style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: '1.2em',
                  }}
                >
                  デザインACのテンプレートを使えばオリジナル暑中見舞いを無料で作成できます
                </h2>
                <p>
                  「デザインAC」を使えば、暑中見舞いを無料で簡単に作成できます。
                </p>
                <ol>
                  <li>
                    好きなデザインの暑中見舞いを選択し「このテンプレートを編集」を押す
                  </li>
                  <li>画像やテキストをカスタマイズする</li>
                  <li>完成した暑中見舞いをダウンロードして印刷する</li>
                </ol>
                <p>
                  画像やテキストを差し替えるだけで、簡単に暑中見舞いに仕上げることができます。かわいいものから、ビジネスにも使えるまで豊富なイラストもご用意しています。お手持ちの写真やイラスト素材は一度に20点までアップロード可能。無料で使える「
                  <a href="https://www.photo-ac.com/">写真AC</a>」と「
                  <a href="https://www.ac-illust.com/">イラストAC</a>
                  」の豊富なフリー素材も手軽に挿入できます。暑中見舞いならではの例文も豊富も用意されているので、文章構成もスムーズです。
                </p>
                <p>
                  作成したデザインは「JPG/PNG/PDF形式」でダウンロード可能。テンプレートはすべてはがきサイズのデザインなので、そのままプリンターで印刷できます。
                </p>
                <p>
                  データはマイページに保存され、修正が必要な際も簡単に呼び出せます。オンライン上で全て完結できる「デザインAC」を使って、オリジナルの暑中見舞いを作成しましょう。
                </p>
              </div>
            )}
        </LayoutEditorAC>
        <style jsx>{`
          .template-page-container__image-banner {
            display: flex;
            flex-direction: column;
            text-align: left;
            color: rgba(12, 18, 28, 0.87);
            position: absolute;
            left: 30px;
            top: 50%;
            transform: translateY(-50%);
          }
          .banner-wrapper.banner {
            height: 350px;
          }
          .banner-wrapper.banner img {
            min-height: 350px;
          }
          .banner-description {
            color: ${colors.textNormal};
            font-size: 15px;
            white-space: pre-line;
          }

          @media screen and (max-width: 480px) {
            .breadcrum-wrapper {
              flex-direction: column;
            }
            .template-page-container__image-banner {
              left: 0;
              padding: 0 14px;
            }
            .banner-wrapper.banner .banner-description {
              font-size: 14px;
            }
          }
        `}</style>
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  currentPageOfCategoryPageTemplate: makeSelectCurrentPage(),
  totalCategoryPageTemplates: makeSelectTotalPage(),
  numberPagesOfCategoryPage: makeSelectNumberPage(),
  templates: makeSelectTemplates(),
  isLoadingCategoryPageTemplates: makeSelectIsLoadingTemplates(),
});

const mapDispatchToProps = (dispatch) => ({
  loadMetaData: (lang) => dispatch(loadMetaData(lang)),
  loadNewContent: (page, role, lang) =>
    dispatch(loadNewContent(page, role, lang)),
  loadPopularContent: (page) => dispatch(loadPopularContent(page)),
  loadSearchContent: (keyword, page) =>
    dispatch(loadSearchContent(keyword, page)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TemplatePageContainer);
